import { render, staticRenderFns } from "./AboutProfile.vue?vue&type=template&id=4c8a18bf&scoped=true"
import script from "./AboutProfile.vue?vue&type=script&lang=js"
export * from "./AboutProfile.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AboutProfile.vue?vue&type=style&index=1&id=4c8a18bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a18bf",
  null
  
)

export default component.exports